import { useParams } from 'react-router-dom';
import { AnnouncementWizard } from '@/components/wizard/AnnouncementWizard';
import { AuthenticatedHeader } from '@/components/layout/AuthenticatedHeader';

export default function EditAnnouncement() {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="min-h-screen bg-hero-gradient">
      <AuthenticatedHeader />
      <AnnouncementWizard announcementId={id} />
    </div>
  );
}
